import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';

export interface IIFrameDialogModel {
    URL: string;
    TopMargin?: number;
}

@Component({
    selector: 'iframe-dialog',
    templateUrl: './iframe.dialog.component.html',
    styleUrls: ['./iframe.dialog.component.scss']
})

export class IFrameDialog extends DialogComponent<IIFrameDialogModel, boolean> implements IIFrameDialogModel, OnInit, OnDestroy {
    IsBusy: boolean = false;

    URL;
    TopMargin: number = 0;
    MarginHeight: string;

    constructor(dialogService: DialogService, public router: Router, private sanitizer: DomSanitizer) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.URL = this.sanitizer.bypassSecurityTrustResourceUrl(this.URL);

        if (this.TopMargin < 0) {
            this.MarginHeight = 'calc(100% + ' + Math.abs(this.TopMargin) + 'px)';
        } else if (this.TopMargin > 0) {
            this.MarginHeight = 'calc(100% - ' + Math.abs(this.TopMargin) + 'px)';
        } else {
            this.MarginHeight = '100%';
        }

    }

}
